import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { AddInstructor, AddWorkout, AddWorkoutType, EditWorkout, getAllWorkouts, GetAllWorkoutsSecured, GetInstructorList, getParticipantEmail, GetSingleWorkout, GetSingleWorkoutSecured, GetWorkoutsTypesList, RemoveInstructor, RemoveParticipant, RemoveWorkoutType, selfRemoveParticipant, UpdateParticipantInfo, UpdateParticipants } from './workoutAPI';
import { InstructorInterface, limitedWorkoutInterface, participant, workoutDetailsInterface, WorkoutTypesInterface } from '../../app/consts';
import { logout} from '../authentication/authenticationSlice';

export interface WorkoutState {
  instructorList: InstructorInterface[],
  allWorkouts: workoutDetailsInterface[],
  limitedAllWorkouts: limitedWorkoutInterface[],
  dateFilter: string;
  activeFilter: string;
  allWorkoutTypes: WorkoutTypesInterface[],
  singleWorkout?: workoutDetailsInterface,
  editFlag: number,
  successFlag: number,
  showParticipantsModal: boolean,
  showEditModal: boolean,
  showManagerNotesModal: boolean,
  singleParticipantEmail?: string
  sortBy: string; 
  asc: boolean;   
}

const initialState: WorkoutState = {
  instructorList: [],
  allWorkouts: [],
  limitedAllWorkouts:[],
  dateFilter: "future",
  activeFilter: "active",
  allWorkoutTypes: [],
  editFlag: 0,
  showParticipantsModal: false,
  showEditModal: false,
  showManagerNotesModal:false,
  successFlag: 0,
  sortBy: 'date',
  asc: true,
};

////////////////////////////////////////////// ASYNC THUNKs /////////////////////////////////////////////////////////////////////////////

///////////////////////////////////////////// NOT SECURED //////////////////////////////////////////////////////////////////////////////

export const GetSingleWorkoutAsync = createAsyncThunk(
  'Workout/GetSingleWorkout',
  async (id: string) => {
    const res = await GetSingleWorkout(id);
    return res;
  }
);

export const updateParticipantsAsync = createAsyncThunk(
  'Workout/updateParticipants',
  async (workoutInfo: { id: string, participantInfo: participant },{rejectWithValue}) => {
    const res = await UpdateParticipants(workoutInfo);
    if (res.result === "success") {
      return res;
    }
    else if (res.result === "failed") {
      return rejectWithValue(res.msg)
    }
  }
);

export const SelfRemoveParticipantAsync = createAsyncThunk(
  'Workout/SelfRemoveParticipantAsync',
  async (data: { workoutId: number, uId: string, personalId: string, phoneNum: string, start: boolean }) => {
    const res = await selfRemoveParticipant(data);
    return res;
  }
);

export const getParticipantEmailAsync = createAsyncThunk(
  'Workout/getParticipantEmail',
  async (data: { workoutId: string, uId: string }) => {
    const res = await getParticipantEmail(data);
    return res;
  }
);

export const getAllWorkoutsAsync = createAsyncThunk(
  'Workout/getAllWorkouts',
  async () =>{
    const res = await getAllWorkouts();
    return res;
  }
)

///////////////////////////////////////////// SECURED //////////////////////////////////////////////////////////////////////////////////

export const GetAllWorkoutsSecureAsync = createAsyncThunk(
  'Workout/GetAllWorkoutsSecured',
  async (data:{dateParam:string,statusParam:string}, { dispatch,rejectWithValue }) => {
    try {
      const res = await GetAllWorkoutsSecured(data);
      return res;
    }
    catch (error: any) {
      if (error?.response?.status === 401) {
        dispatch(logout("auto"));
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetSingleWorkoutSecuredAsync = createAsyncThunk(
  'Workout/GetSingleWorkoutSecured',
  async (id: string, { dispatch,rejectWithValue }) => {
    try {
      const res = await GetSingleWorkoutSecured(id);
      return res;
    }
    catch (error: any) {
      if (error?.response?.status === 401) {
        dispatch(logout("auto"));
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const AddWorkoutAsync = createAsyncThunk(
  'Workout/AddWorkout',
  async (workout: workoutDetailsInterface, { dispatch,rejectWithValue }) => {
    try {
      const res = await AddWorkout(workout);
      return res;
    }
    catch (error: any) {
      if (error?.response?.status === 401) {
        dispatch(logout("auto"));
      }
      return rejectWithValue(error?.response?.data);

    }
  }
);

export const EditWorkoutAsync = createAsyncThunk(
  'Workout/EditWorkout',
  async (workoutInfo: { id: string, workout: workoutDetailsInterface }, { dispatch,rejectWithValue }) => {
    try {
      const res = await EditWorkout(workoutInfo);
      return res;
    }
    catch (error: any) {
      if (error?.response?.status === 401) {
        dispatch(logout("auto"));
      }
      return rejectWithValue(error?.response?.data);

    }
  }
);

export const GetInstructorAsync = createAsyncThunk(
  'Workout/GetInstructor',
  async (_, { dispatch,rejectWithValue }) => {
    try {
      const res = await GetInstructorList();
      return res;
    }
    catch (error: any) {
      if (error?.response?.status === 401) {
        dispatch(logout("auto"));
      }
      return rejectWithValue(error?.response?.data);

    }
  }
);

export const AddInstructorAsync = createAsyncThunk(
  'Workout/AddInstructor',
  async (instructor: { fullName: string, phoneNumber: string }, { dispatch,rejectWithValue }) => {
    try {
      const res = await AddInstructor(instructor);
      return res;
    }
    catch (error: any) {
      if (error?.response?.status === 401) {
        dispatch(logout("auto"));
      }
      return rejectWithValue(error?.response?.data);

    }
  }
);

export const GetWorkoutTypesAsync = createAsyncThunk(
  'Workout/GetWorkoutTypes',
  async (_, { dispatch,rejectWithValue }) => {
    try {
      const res = await GetWorkoutsTypesList();
      return res;
    }
    catch (error: any) {
      if (error?.response?.status === 401) {
        dispatch(logout("auto"));
      }
      return rejectWithValue(error?.response?.data);

    }
  }
);

export const AddWorkoutTypeAsync = createAsyncThunk(
  'Workout/AddWorkoutType',
  async (workoutType: { name: string }, { dispatch,rejectWithValue }) => {
    try {
      const res = await AddWorkoutType(workoutType);
      return res;
    }
    catch (error: any) {
      if (error?.response?.status === 401) {
        dispatch(logout("auto"));
      }
      return rejectWithValue(error?.response?.data);

    }
  }
);

export const RemoveParticipantAsync = createAsyncThunk(
  'Workout/RemoveParticipant',
  async (data: { workoutId: number, participantUniqueId: string }, { dispatch,rejectWithValue }) => {
    try {
      const res = await RemoveParticipant(data);
      return res;
    }
    catch (error: any) {
      if (error?.response?.status === 401) {
        dispatch(logout("auto"));
      }
      return rejectWithValue(error?.response?.data);

    }
  }
);

export const UpdateParticipantInfoAsync = createAsyncThunk(
  'Workout/UpdateParticipantInfo',
  async (data: { workoutId: number, participantUniqueId: string, updatedData:participant }, { dispatch,rejectWithValue }) => {
    try {
      const res = await UpdateParticipantInfo(data);
      return res;
    }
    catch (error: any) {
      if (error?.response?.status === 401) {
        dispatch(logout("auto"));
      }
      return rejectWithValue(error?.response?.data);

    }
  }
);

export const RemoveInstructorAsync = createAsyncThunk(
  'Workout/RemoveInstructor',
  async (id: number, { dispatch,rejectWithValue }) => {
    try {
      const res = await RemoveInstructor(id);
      return res;
    }
    catch (error: any) {
      if (error?.response?.status === 401) {
        dispatch(logout("auto"));
      }
      return rejectWithValue(error?.response?.data);

    }
  }
);

export const RemoveWorkoutTypeAsync = createAsyncThunk(
  'Workout/RemoveWorkoutType',
  async (id: number, { dispatch,rejectWithValue }) => {
    try {
      const res = await RemoveWorkoutType(id);
      return res;
    }
    catch (error: any) {
      if (error?.response?.status === 401) {
        dispatch(logout("auto"));
      }
      return rejectWithValue(error?.response?.data);

    }
  }
);

/////////////////////////////////////////////// FUNCTIONS //////////////////////////////////////////////////////////

const mySortData = (state: WorkoutState, action: { payload: { by: string; type: string; asc?: boolean } }) => {
  state.sortBy = action.payload.by;
  state.asc = action.payload.asc ?? true;

  const data = action.payload.type === "complete" ? [...state.allWorkouts] : [...state.limitedAllWorkouts];
  let result = []
  switch (state.sortBy) {
    case 'date':
      result = data.sort((a, b) => {
        let x = a.date;
        let y = b.date;
        if (x === y) {
          if (a.time > b.time)
            return state.asc  ? -1 : 1;
        }
        if (x < y) { return state.asc ?  -1 : 1 }
        if (x > y) { return state.asc ?  1 : -1 }
        return 0;
      });
      setEditFlag();
      break;

    case 'type':
      result = data.sort((a, b) => {
        let x = a.type.id;
        let y = b.type.id;
        if (x < y) { return state.asc ?  -1 : 1 }
        if (x > y) { return state.asc ?  1 : -1 }
        return 0;
      });
      setEditFlag();
      break;

    case 'instructor':
      result = data.sort((a, b) => {
        let x = a.instructor.id;
        let y = b.instructor.id;
        if (x < y) { return state.asc ?  -1 : 1 }
        if (x > y) { return state.asc ?  1 : -1 }
        return 0;
      });
      setEditFlag();
      break;

    case 'location':
      result = data.sort((a, b) => {
        let x = a.location;
        let y = b.location;
        if (x < y) { return state.asc ?  -1 : 1 }
        if (x > y) { return state.asc ?  1 : -1 }
        return 0;
      });
      setEditFlag();
      break;

    case 'maximumParticipants':
      result = data.sort((a, b) => {
        return state.asc ? 
        a.maximumParticipants - b.maximumParticipants 
        : b.maximumParticipants - a.maximumParticipants;
      });
      setEditFlag();
      break;
  }

  if(action.payload.type === "complete"){
    state.allWorkouts = result
  }
  else if(action.payload.type === "limited"){
    state.limitedAllWorkouts = result
  }
}

/////////////////////////////////////////////////////////// SLICE ///////////////////////////////////////////////////////////////////////////////////////

export const WorkoutSlice = createSlice({
  name: 'Workout',
  initialState,
  reducers: {
    setEditFlag: (state) => {
      state.editFlag++;
    },
    setSuccessFlag: (state) => {
      state.successFlag++;
    },
    sortData: mySortData,
    setShowManagerNotesModal: (state, action) => {
      state.showManagerNotesModal = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllWorkoutsSecureAsync.fulfilled, (state, action) => {
        state.allWorkouts = action.payload;
        mySortData(state,{payload:{by: "date", type:"complete" ,asc:true}})
      })
      .addCase(GetSingleWorkoutAsync.fulfilled, (state, action) => {
        state.singleWorkout = action.payload;
      })
      .addCase(GetSingleWorkoutSecuredAsync.fulfilled, (state, action) => {
        state.singleWorkout = action.payload;
      })
      .addCase(GetInstructorAsync.fulfilled, (state, action) => {
        state.instructorList = action.payload
      })
      .addCase(GetWorkoutTypesAsync.fulfilled, (state, action) => {
        state.allWorkoutTypes = action.payload
      })
      .addCase(getParticipantEmailAsync.fulfilled, (state, action) => {
        state.singleParticipantEmail = action.payload.email
      })
      .addCase(getAllWorkoutsAsync.fulfilled,(state,action)=>{
        state.limitedAllWorkouts = action.payload
        mySortData(state,{payload:{by: "date", type:"limited" ,asc:true}})
      })
      .addCase(GetAllWorkoutsSecureAsync.rejected, (state) => {
        state.allWorkouts = [];
      })
      .addCase(GetSingleWorkoutSecuredAsync.rejected, (state) => {
        state.singleWorkout = undefined;
      })
      .addCase(GetInstructorAsync.rejected, (state) => {
        state.instructorList = [];
      })
      .addCase(GetWorkoutTypesAsync.rejected, (state) => {
        state.allWorkoutTypes = [];
      })
      .addCase(getParticipantEmailAsync.rejected, (state) => {
        state.singleParticipantEmail = "";
      })
  },
});

export const { setEditFlag, sortData, setSuccessFlag,setShowManagerNotesModal } = WorkoutSlice.actions;

export const selectWorkouts = (state: RootState) => state.Workout.allWorkouts;
export const selectLimitedWorkouts = (state: RootState) => state.Workout.limitedAllWorkouts;
export const selectSingleWorkout = (state: RootState) => state.Workout.singleWorkout;
export const selectInstructorList = (state: RootState) => state.Workout.instructorList;
export const selectWorkoutTypesList = (state: RootState) => state.Workout.allWorkoutTypes;
export const selectEditFlag = (state: RootState) => state.Workout.editFlag;
export const selectShowParticipantsModal = (state: RootState) => state.Workout.showParticipantsModal;
export const selectShowEditModal = (state: RootState) => state.Workout.showEditModal;
export const selectSingleParticipantEmail = (state: RootState) => state.Workout.singleParticipantEmail;
export const selectShowManagerNotesModal = (state: RootState) => state.Workout.showManagerNotesModal;
export const selectSortBy = (state: RootState) => state.Workout.sortBy;
export const selectAsc = (state: RootState) => state.Workout.asc;

export default WorkoutSlice.reducer;
